<template>
  <div>
    <div class="container-fluid">
      <div class="row orta">
        <div class="col-md-8">
          <vx-card>
            <div class="container-fluid">
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="center"
                  vs-align="center"
                  vs-lg="12"
                  vs-sm="12"
                  vs-md="12"
                >
                  <h3>{{ $t('addTariff') }}</h3>
                </vs-col>
              </vs-row>
              <vs-row>
                <vs-col
                  vs-type="flex"
                  vs-justify="flex-start"
                  vs-align="flex-start"
                  vs-lg="6"
                  vs-sm="6"
                  vs-md="6"
                >
                  <vs-button icon="arrow_back" to="/tarrifs">{{ $t('back') }}</vs-button>
                </vs-col>

                <vs-col
                  vs-type="flex"
                  vs-justify="flex-end"
                  vs-align="flex-end"
                  vs-lg="6"
                  vs-sm="6"
                  vs-md="6"
                >
                  <vs-button
                    icon="save"
                    :disabled="!validateForm"
                    @click="addTariff"
                  >{{ $t('save') }}</vs-button>
                </vs-col>
              </vs-row>

              <div class="row">
                <div class="col-md-6 mt-6">
                  <vs-input
                    v-validate="'required'"
                    :name="$t('tariffName')"
                    :label-placeholder="$t('tariffName')"
                    v-model="tariff.TariffName"
                    class="w-full mt-6"
                  />
                  <span class="text-danger text-sm">{{ errors.first($t('tariffName')) }}</span>
                </div>
                <div class="col-md-6 mt-6">
                  <vs-select
                    v-validate="'required'"
                    :name="$t('customerStatus')"
                    class="selectExample w-full mt-6"
                    :placeholder="$t('customerStatus')"
                    autocomplete
                    v-model="tariff.Active"
                  >
                    <vs-select-item
                      :key="index"
                      :value="item.Active"
                      :text="item.name"
                      v-for="(item,index) in select"
                    />
                  </vs-select>
                  <span class="text-danger text-sm">{{ errors.first($t('customerStatus')) }}</span>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 mt-6">
                  <vs-textarea
                    :placeholder="$t('description')"
                    v-model="tariff.Description"
                    height="150px"
                  />
                </div>
                <div class="col-md-6 mt-6">
                  <div class="row">
                    <div class="col-md-12 mt-3">
                      <vs-input
                        v-validate="'required'"
                        :name="$t('value')"
                        :label-placeholder="$t('value')"
                        v-model="tariff.Value"
                        class="w-full mt-6"
                        type="number"
                      />
                      <span class="text-danger text-sm">{{ errors.first($t('value')) }}</span>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 mt-3">
                      <vs-input
                        v-validate="'required'"
                        :name="$t('price')"
                        :label-placeholder="$t('price')"
                        v-model="tariff.Price"
                        class="w-full mt-6"
                        type="number"
                      />
                      <span class="text-danger text-sm">{{ errors.first($t('price')) }}</span>
                    </div>
                  </div>
                </div>
              </div>


              
            </div>
          </vx-card>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import http from "../../../http/http-helper";
export default {
  computed: {
    validateForm() {
      return (
        !this.errors.any() &&
        this.tariff.TariffName != "" &&
        this.tariff.Value != "" &&
        this.tariff.Value != "" &&
        this.tariff.Price != "" &&
        this.tariff.Active != ""
      );
    }
  },
  data() {
    return {
      tariff: {
        TariffName: "",
        Description: "",
        Value: "",
        Price: "",
        Active: true
      },
      select: [
        { name: this.$t("active"), Active: true },
        { name: this.$t("passive"), Active: false }
      ]
    };
  },
  methods: {
    addTariff() {
      if (this.tariff.TariffName == "")
        return this.$vs.notify({
          title: this.$t("fillTariffName"),
          color: "warning"
        });
      if (this.tariff.Value == "")
        return this.$vs.notify({
          title: this.$t("fillValue"),
          color: "warning"
        });
      if (this.tariff.Price == "")
        return this.$vs.notify({
          title: this.$t("fillPrice"),
          color: "warning"
        });
      let path = "/tariffs/add";
      this.$vs.loading();
      var data = {
        TariffName: this.tariff.TariffName,
        Description: this.tariff.Description,
        Value: parseInt(this.tariff.Value),
        Price: parseInt(this.tariff.Price),
        Active: this.tariff.Active
      };
      http.post(path, data).then(response => {
        this.tariff.TariffName = "";
        this.tariff.Description = "";
        this.tariff.Price = "";
        this.tariff.Value = "";

        this.$vs.loading.close();
        this.$router.push("/tarrifs");
        notify.success(this.$t("saved"), response.message);
      });
    }
  }
};
</script>
<style scoped>
.orta {
  display: flex;
  justify-content: center;
}
</style>